<template>
  <div id="home">
    <div class="px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
      <h1 class="display-4 mr-2">Examples</h1>
      <p class="lead mt-3">The following examples illustrate how to use the silversky Data Pool API.</p>
    </div>

    <div class="card-deck mb-3">
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Featured</h4>
        </div>
        <div class="card-body">
          <div v-for="(example, id) in $parent.featured" v-bind:key="id">
            <a href="#browse" v-on:click="browse(example)">/{{example}}</a>
          </div>
        </div>
      </div>
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Query</h4>
        </div>
        <div class="card-body">
          <div v-for="(example, id) in query" v-bind:key="id">
            <a href="#browse" v-on:click="browse(example)">/{{example}}</a>
          </div>
        </div>
      </div>
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Other</h4>
        </div>
        <div class="card-body">
          <div v-for="(example, id) in other" v-bind:key="id">
            <a href="#browse" v-on:click="browse(example)">/{{example}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="card-deck mb-3">
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Latest</h4>
        </div>
        <div class="card-body">
          <div v-for="(example, id) in latest" v-bind:key="id">
            <a href="#browse" v-on:click="browse(example)">/{{example}}</a>
          </div>
        </div>
      </div>
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Historic</h4>
        </div>
        <div class="card-body">
          <div v-for="(example, id) in historic" v-bind:key="id">
            <a href="#browse" v-on:click="browse(example)">/{{example}}</a>
          </div>
        </div>
      </div>
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Wildcard</h4>
        </div>
        <div class="card-body">
          <div v-for="(example, id) in wildcard" v-bind:key="id">
            <a href="#browse" v-on:click="browse(example)">/{{example}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: function() {
    return {
      query: [
        'latest/AAPL,GOOG,MSFT/PE',
        'latest/SWX:*/MarketCap',
        'all/ETR:VOW3',
        'latest/10/AAPL',
        'latest/XAUUSD'
      ],
      other: [
        'keys',
        'records',
        'latest[type=demo]',
        'all/log',
        'all/di*'
      ],
      latest: [
        'latest[type=currency]',
        'latest[type=equity]',
        'latest[type=crypto]',
        'latest[type=commodity]',
        'latest/10/coin'
      ],
      historic: [
        'historic/2019-11-24/BTCUSD',
        'historic/2019-11-23/XAUUSD',
        'historic/2019-11-22/coin',
        'historic/2019-11-21'
      ],
      wildcard: [
        'latest/*ReleaseDate',
        'latest/SWX:*',
        'latest/INDEX:*',
        'historic/2019-11-22/E*USD',
        'all/X*'
      ]
    }
  },
  methods: {
    browse: function(query) {
      this.$parent.browse(query);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
